import React from 'react'

export const BtnLoading = () => {
    return (
      <div className='btnLoad'>
            <div className="btnLoader">
                <span className="strip"></span>
                <span className="strip"></span>
                <span className="strip"></span>
            </div>
        </div>
  )
}
